// References to fetch and Response prototype methods, captured at
// module-evaluation time. Routing the request layer through these
// makes our network calls invisible to any later reassignment of
// window.fetch or override of Response.prototype.{clone,json,text}
// performed by post-load scripts (e.g. a `javascript:` bookmarklet).

export const NATIVE_FETCH = window.fetch.bind(window);
export const NATIVE_CLONE = Response.prototype.clone;
export const NATIVE_JSON = Response.prototype.json;
export const NATIVE_TEXT = Response.prototype.text;
